<template>
  <section>
    <navbar-dashboard name="Editar origen" v-if="currentStep === 1"></navbar-dashboard>
    <section class="ew-smaller-container" v-if="currentStep === 1">
      <div class="ew-card">
        <form @submit.prevent="updateShipment" class="ew-form">
          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="eso-name">Nombre completo de quien envía</label>
              <input id="eso-name" type="text" maxlength="35" class="ew-input ew-input--block" v-model.trim="origin_direction.full_name" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="eso-email">Correo electrónico de quien envía</label>
              <input id="eso-email" type="email" class="ew-input ew-input--block" v-model.trim="origin_direction.email" required>
            </div>
          </div>
          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="eso-phone">Teléfono de contacto</label>
              <input id="eso-phone" type="tel" pattern="[0-9]{3,25}" class="ew-input ew-input--block" v-model.trim="origin_direction.phone" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="eso-address">Dirección de origen</label>
              <input id="eso-address" type="text" maxlength="35" class="ew-input ew-input--block" v-model.trim="origin_direction.address" required>
            </div>
          </div>
          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="eso-reference">Referencias de origen</label>
              <input id="eso-reference" type="text" maxlength="35" class="ew-input ew-input--block" v-model.trim="origin_direction.reference_of_origin">
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="eso-colony">Colonia</label>
              <input id="eso-colony" type="text" maxlength="35" class="ew-input ew-input--block" v-model.trim="origin_direction.colony" required>
            </div>
          </div>

          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="eso-zip">Código postal</label>
              <input id="eso-zip" type="number" max="999999999999" class="ew-input ew-input--block" v-model.trim="origin_direction.postal_code" @keyup="checkAddressOrigin" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="eso-city">Estado y ciudad</label>
              <input id="eso-city" type="text" maxlength="35" class="ew-input ew-input--block" v-model.trim="origin_direction.city" disabled required>
            </div>
          </div>

          <div class="ew-form__actions">
            <router-link class="ew-btn-outline" :to="'/shipments/' + $route.params['id']">Cancelar</router-link>
            <button class="ew-btn-primary" type="button" v-if="zipChanged" @click="currentStep = 2">Seleccionar paquetería</button>
            <button class="ew-btn-primary" type="submit" v-if="!zipChanged">Aplicar cambios</button>
          </div>
        </form>
      </div>
    </section>

    <ServiceProviderSelector v-if="currentStep === 2" :origin="origin_direction" :destination="destination_direction" :parcels="parcels" :insurance="insurance_information" :primary-action-text="primaryActionText" :secondary-action-text="secondaryActionText" @primary-action="updateShipmentWithNewSO" @secondary-action="currentStep = 1" />
  </section>
</template>

<script>
import axios from 'axios'
import commons from '../../commons'
import api from '../../commons/api'
import ServiceProviderSelector from '../ServiceProviderSelector'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Navbar from '../Header/Navbar'
export default {
  name: 'EditShipmentOrigin',
  data () {
    return {
      currentStep: 1,
      initialOriginZipCode: '',
      newShipmentOptionSelected: true,

      selectedShippingOptionIndex: -1,

      origin_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },

      destination_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },

      description_of_the_content: '',
      package_insurance: false,

      insurance_information: {
        package_value: null,
        responsible_for_the_package: null,
        mail_responsible: null,
        cost: null
      },

      parcels: [
        {
          depth: '',
          width: '',
          height: '',
          weight: ''
        }
      ],

      requestBody: {
        origin_direction: {
          country_code: '',
          postal_code: '',
          city: '',
          suburb: ''
        },

        parcels: [
          {
            weight: '',
            height: '',
            depth: '',
            width: ''
          }
        ],
        destination_direction: {
          country_code: '',
          postal_code: '',
          city: '',
          suburb: ''
        },
        insured_value: '',
        insured_value_currency: 'MXN'
      },

      primaryActionText: 'Aplicar Cambios',
      secondaryActionText: 'Cancel'
    }
  },
  methods: {
    addParcel () {
      this.parcels.push({
        depth: '',
        width: '',
        height: '',
        weight: ''
      })
    },
    removeParcel (index) {
      if (this.parcels.length > 1) {
        this.parcels.splice(index, 1)
        console.log(this.parcels)
      }
    },

    updateShipment () {
      this.setSelectedShippingOption(
        this.shippingOptions[this.selectedShippingOptionIndex]
      )

      const requestBody = {
        origin_direction: this.origin_direction
      }

      this.setNewShipmentRequestBody(requestBody)
      api.shipment.update(this.$route.params['id'], requestBody).then(() => {
        this.getAllShipments()
        this.$router.push(`/shipments/${this.$route.params['id']}`)
      })
    },

    updateShipmentWithNewSO (newSO) {
      const requestBody = {
        origin_direction: this.origin_direction,
        selected_service: newSO
      }

      this.setNewShipmentRequestBody(requestBody)

      api.shipment.update(this.$route.params['id'], requestBody).then(() => {
        this.getAllShipments()
        this.$router.push(`/shipments/${this.$route.params['id']}`)
      })
    },

    calculateQuote () {
      console.log('calculateQuote')

      this.requestBody.parcels = this.parcels

      this.requestBody.origin_direction = {
        country_code: this.origin_direction.country_code,
        postal_code: this.origin_direction.postal_code,
        city: this.origin_direction.city,
        suburb: this.origin_direction.colony
      }

      this.requestBody.destination_direction = {
        country_code: this.destination_direction.country_code,
        postal_code: this.destination_direction.postal_code,
        city: this.destination_direction.city,
        suburb: this.destination_direction.colony
      }

      if (this.package_insurance) {
        this.insured_value = this.insurance_information.cost
      } else {
        delete this.insured_value
      }

      this.setQuotingRequestBody(this.requestBody)

      this.quoting()
        .then(() => {
          this.nextStep()
        })
        .catch(error => console.log(error))
    },

    createShipment () {
      this.setSelectedShippingOption(
        this.shippingOptions[this.selectedShippingOptionIndex]
      )

      const requestBody = {
        selected_service: {
          full_name: this.selectedShippingOption.product_short_name,
          mount: this.selectedShippingOption.shipping_charge,
          logo_url: this.selectedShippingOption.logo_url,
          delivery_time: this.selectedShippingOption.delivery_date,
          pickup_date: this.selectedShippingOption.pickup_date,
          currency_code: this.selectedShippingOption.currency_code
        },
        shipment_type: this.quotingRequestBody.shipment_type,
        parcels: this.quotingRequestBody.parcels,
        origin_direction: this.origin_direction,
        destination_direction: this.destination_direction,
        description_of_the_content: this.description_of_the_content,
        package_insurance: this.package_insurance,
        insurance_information: this.insurance_information,
        user: localStorage.getItem('ew-user-id')
      }

      this.setNewShipmentRequestBody(requestBody)
      this.newShipment().then(() => {
        this.getAllShipments()
        this.$router.push('/dashboard')
      })
    },

    checkAddressOrigin (event) {
      // console.log(event)
      const query = event.target.value
      if (query.length >= 5) {
        this.getLocationInfo(query, 'MX').then(response => {
          console.log(response.data)
          this.origin_direction.city =
            response.data.country_codes[0].state +
            ', ' +
            response.data.country_codes[0].city
        })
      }
    },
    checkAddressDestination (event) {
      // console.log(event)
      const query = event.target.value
      if (query.length >= 3) {
        this.getLocationInfo(query, 'MX').then(response => {
          // console.log(response.data)
          this.destination_direction.city =
            response.data.country_codes[0].state +
            ', ' +
            response.data.country_codes[0].city
        })
      }
    },
    getLocationInfo (zipCode, countryCode) {
      return axios.get(
        `${
          commons.apiURL
        }/api/v1/postalcodes?search=${zipCode}&country=${countryCode}`
      )
    },
    ...mapMutations([
      'netNewShipmentRequestBody',
      'setQuotingRequestBody',
      'setSelectedShippingOption',
      'setNewShipmentRequestBody'
    ]),
    ...mapActions(['quoting', 'newShipment', 'getAllShipments'])
  },
  computed: {
    zipChanged () {
      if (this.initialOriginZipCode !== this.origin_direction.postal_code) {
        return true
      } else {
        return false
      }
    },

    ...mapGetters([
      'quotingRequestBody',
      'selectedShippingOption',
      'serviceProviders',
      'shippingOptions'
    ])
  },
  components: {
    ServiceProviderSelector: ServiceProviderSelector,
    'navbar-dashboard': Navbar
  },
  created () {
    api.shipment.getByID(this.$route.params['id']).then(response => {
      this.origin_direction = response.data.origin_direction
      this.destination_direction = response.data.destination_direction
      this.parcels = response.data.parcels
      this.insurance_information = response.data.insurance_information
      this.initialOriginZipCode = this.origin_direction.postal_code
    })
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/app-tokens";
@import "../../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 700px; margin: 2.5rem auto; padding: 0 1rem 4rem; }
.ew-card { @include ew-card; padding: 1.5rem 1.75rem; }
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }
.ew-form { display: flex; flex-direction: column; gap: 1rem; max-width: none; }
.ew-form__row { display: flex; flex-wrap: wrap; gap: 1rem; > .ew-form__field { flex: 1 1 220px; min-width: 0; } }
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; }
.ew-form__actions { display: flex; justify-content: flex-end; gap: 0.6rem; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; }
.ew-input--block { width: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/editShipment/EditShipmentOrigin.vue